
import React from 'react';
import { PlatformLogoSkeleton } from './PlatformLogoSkeleton';
import { ImageWithFallback } from '@/components/common/ImageWithFallback';
import { useIsMobile } from '@/hooks/use-mobile';

interface PlatformLogoProps {
  name: string;
  logo: string;
  loading?: boolean;
  customSize?: string;
}

export const PlatformLogo = ({ 
  name, 
  logo, 
  loading = false, 
  customSize 
}: PlatformLogoProps) => {
  const isMobile = useIsMobile();
  const logoSize = customSize || (isMobile ? 'h-8 w-8' : 'h-12 w-12');
  
  if (loading) return <PlatformLogoSkeleton className={logoSize} />;
  return (
    <div className={`${logoSize} overflow-hidden rounded-lg border border-border bg-background`}>
      <ImageWithFallback 
        src={logo} 
        alt={`${name} logo`} 
        className="h-full w-full object-contain"
        draggable={false}
        showSkeleton={true}
        skeletonClassName="bg-muted/50"
        priority="high"
      />
    </div>
  );
};
